const MembershipTiersTable = () => {
  const eligibilityCriterias = [
    {
      key: "1",
      label: "Group 1 - High School Performance",
      requirements: "High school graduates with a GPA of at least 99%",
    },
    {
      key: "2",
      label: "Group 2 - Bachelor's Degree",
      requirements:
        "Holders of Bachelor's degree from a Top 100 University in global rankings",
    },
    {
      key: "3",
      label: "Group 3 - Master's Degree",
      requirements:
        "Holders of Master's degree from a Top 100 University in global rankings",
    },
    {
      key: "4",
      label: "Group 4 - PhD",
      requirements:
        "Holders of PhD from a Top 100 University in global rankings",
    },
  ];

  return (
    <div className="overflow-x-auto rounded-lg border border-neutral-light">
      <table className="min-w-full divide-y divide-neutral-light">
        <thead className="bg-neutral-50">
          <tr>
            <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700 font-verona">
              Eligibility Criteria
            </th>
            <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700 font-verona">
              Requirements
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-neutral-light">
          {eligibilityCriterias.map((criteria) => (
            <tr key={criteria.key}>
              <td className="px-6 py-4 text-sm text-gray-700">
                <div className="flex items-center">
                  <span className="font-verona">{criteria.label}</span>
                </div>
              </td>
              <td className="px-6 py-4 text-sm text-gray-700 font-verona">
                {criteria.requirements}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MembershipTiersTable;
